import { forwardRef, useEffect, useRef, useState } from "react";

/*eslint-disable */

declare const window: any;

interface MotorVehiculosComponentProps {
  motores: any;
}

const MotorVehiculosComponent = forwardRef<
  HTMLDivElement,
  MotorVehiculosComponentProps
>(({ motores }, ref) => {
  const infoContainerRef = useRef<HTMLDivElement | null>(null);
  const infoItemsRef = useRef<(HTMLDivElement | null)[]>([]);
  const imageContainerRef = useRef<HTMLDivElement | null>(null);
  const imageItemsRef = useRef<(HTMLDivElement | null)[]>([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Escucha el evento de cambio de tamaño
    window.addEventListener("resize", handleResize);

    // Limpieza para evitar fugas de memoria
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Función para centrar un item dentro de su contenedor
  const scrollToCenter = (
    container: HTMLDivElement | null,
    item: HTMLDivElement | null
  ) => {
    if (!container || !item) return;

    const containerRect = container.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    const offset =
      itemRect.left -
      containerRect.left +
      container.scrollLeft -
      container.clientWidth / 2 +
      itemRect.width / 2;

    container.scrollTo({
      left: offset,
      behavior: "smooth",
    });
  };

  // mover scroll cuando cambia el index
  useEffect(() => {
    scrollToCenter(
      imageContainerRef.current,
      imageItemsRef.current[currentIndex]
    );
    scrollToCenter(
      infoContainerRef.current,
      infoItemsRef.current[currentIndex]
    );
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : motores?.engine?.gallery?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < motores?.engine?.gallery?.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="motores-vehiculos-detail-component" ref={ref}>
      <div
        className="title-motores-vehiculos-detail-component"
        style={{ textAlign: motores?.engine?.alignment }}
      >
        {motores?.engine?.module_title}
      </div>

      <div
        ref={infoContainerRef}
        className="info-motores-vehiculos-detail-component"
        alt-data={window.innerWidth}
        style={
          motores?.engine?.gallery?.length === 3 && window.innerWidth > 1540
            ? { justifyContent: "center" }
            : (motores?.engine?.gallery?.length === 2 &&
                window.innerWidth > 1065) ||
              (motores?.engine?.gallery?.length === 2 &&
                window.innerWidth > 630 &&
                window.innerWidth < 768)
            ? { justifyContent: "center" }
            : motores?.engine?.gallery?.length === 1
            ? { justifyContent: "center" }
            : {}
        }
      >
        <div
          className="btn-carrousel-motores-vehiculos-detail-component prev"
          onClick={handlePrev}
        >
          <img
            src="/assets/01_Home/Icon_Left.svg"
            alt="Ícono de flecha izquierda"
          />
        </div>
        {motores?.engine?.gallery?.map((item: any, index: number) => (
          <div
            ref={(el) => (infoItemsRef.current[index] = el)}
            className={`item-info-motores-vehiculos-detail-component ${
              index === currentIndex ? "active" : ""
            }`}
            onClick={() => setCurrentIndex(index)}
            key={index}
          >
            {item?.media_type === "img" ? (
              <img
                className="media-info-motores-vehiculos-detail-component"
                src={`https://manager.hyundaicolombia.co/${item.media?.url}`}
                alt={item.media_title || ""}
              />
            ) : item?.media_type === "video" ? (
              <video
                className="media-info-motores-vehiculos-detail-component"
                src={`https://manager.hyundaicolombia.co/${item.media?.url}`}
                autoPlay
                muted
                loop
                playsInline
              />
            ) : null}

            <div className="title-info-motores-vehiculos-detail-component">
              {item.media_title}
            </div>
            <div className="descripcion-info-motores-vehiculos-detail-component">
              {item.media_description}
            </div>
          </div>
        ))}

        <div
          className="btn-carrousel-motores-vehiculos-detail-component next"
          onClick={handleNext}
        >
          <img
            src="/assets/01_Home/Icon_Right.svg"
            alt="Ícono de flecha derecha"
          />
        </div>
      </div>

      {motores?.engine?.legals && (
        <div className="description-motores-vehiculos-detail-component">
          {motores?.engine?.legals}
        </div>
      )}
    </div>
  );
});

export default MotorVehiculosComponent;
